import { Box, Button, Fab} from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
  allImprestSurrender,
  imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import {
  AllImprestSurrenderColumns,
  LeaveApplicationsColumns,
  imprestApplicationsColumns,
  imprestSurrenderLinesColumns,
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import ImprestSurrenderForm from "./form";
import SurrenderLineForm from "./surrenderLineForm";
import { useNavigate } from "react-router-dom";

function ImprestSurrenderLineTable() {
  const data = JSON.parse(localStorage.getItem("SurrenderId"));
  const base_url = HRService.uri;
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/imprest-applications');
  };

  const actions = {
    entity: "Surrender Line",

    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "hasNoPermission", 
      roleGroupId: [1, 2, 3, 4], 

    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },

    removeSurrenderLine: {
      key: "REMOVE_RELIEVER",
      button_name: "Remove Line",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2],
    },
    dataObjectForMutation: {
      isSurrenderLine: true,
      inputObjectName: "addRemoveImprestSurrenderLines",
      inputSubObjectName: "lines",
      inputFields: ["applicationId", "userId", "comments"],
      actionName: "Leave Application ",
    },

    dataObject: {
      inputFields: {
        surrenderId: data ? data.id : null,
      },
      inputObjectName: "imprestSurrenderLinesByImprestId",
      inputSubObjectName: "imprestSurrenderLines",
      returnFields: [
        "id",
        "surrenderId",
        "description",
        "applicationLineId",
        "amountRequested",
        "amountSpent",
        "accountId",
      ],
    },
    showStatus: true,
  };
  return (
    <Box m="2px">
      {/* Floating Back Button – same style as EmployeePayTable */}
        <Fab
          color="secondary"
          aria-label="go back"
          onClick={handleGoBack}
          sx={{
            position: "fixed",
            top: 120,      
            left: 260,     
            zIndex: 1100,
            width: 35,
            height: 35,
            boxShadow: 3,
            "&:hover": {
            boxShadow: 6,
            },
          }}
        >
        <ArrowBackIcon />
        </Fab>
    <>
        <DynamicTable
          title="Imprest Surrender Lines"
          subtitle="View all imprest Surrenderrs, add or remove"
          columns={imprestSurrenderLinesColumns}
          FormComponent={SurrenderLineForm}
          //  query={allImprestSurrender}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default ImprestSurrenderLineTable;
